import { combineReducers } from "redux";
import language from "./language";
import pageHome from "./page/home";
import post from "./page/post";
import pageCareer from "./page/career";
import postcategories from "./page/postcategories";
import promotions from "./page/promotion";
import promotionCategories from "./page/promotioncategories";
import events from "./page/event";
import positions from "./page/careerpositions";
import pageContact from "./page/contact";
import promotionPage from "./page/promotionpage";
import newsPage from "./page/newspage";
import eventPage from "./page/eventpage";
import ourshowPage from "./page/ourshowpage";
import highlightshowPage from "./page/highlightshowpage";
import auth from "./page/auth";

export default combineReducers({
  language,
  home: pageHome,
  career: pageCareer,
  postcategories: postcategories,
  posts: post,
  promotion: promotions,
  promotionCategories: promotionCategories,
  event: events,
  positions: positions,
  contact: pageContact,
  promotionPage,
  newsPage,
  eventPage,
  ourshowPage,
  highlightshowPage,
  auth
});



// WEBPACK FOOTER //
// ./src/reducers/index.js